import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@lecartte/shared-ui/components/Button';
import { FormInput } from '@lecartte/shared-ui/components/FormInput';
import { useAuth } from '@/contexts/AuthContext';
import logoSrc from '@/assets/logo.svg';

export function LoginPage() {
  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    const result = await login({ email, password });
    if (result.error) {
      setError(result.error);
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="flex min-h-screen">
      {/* Left — form */}
      <div className="flex w-full flex-col justify-center px-12 py-16 lg:w-[42%]">
        <div className="mx-auto w-full max-w-sm">
          {/* Logo */}
          <div className="mb-10 flex items-center gap-3">
            <img src={logoSrc} alt="LeCartte Console" className="h-9 w-20 rounded-xl object-cover" />
            <span className="rounded-md bg-primary px-2 py-0.5 text-xs font-bold uppercase tracking-widest text-white">
              Console
            </span>
          </div>

          <h1 className="text-3xl font-black uppercase tracking-tight text-slate-900">Login</h1>
          <p className="mt-2 text-sm font-medium text-primary">
            Bem-vindo(a)!<br />
            Insira seus dados para entrar na sua conta.
          </p>

          <form onSubmit={handleSubmit} className="mt-8 flex flex-col gap-4">
            {error && (
              <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                {error}
              </div>
            )}

            <FormInput
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="E-mail"
              className="w-full border-l-4 border-l-primary bg-slate-200 px-4 py-3 text-sm text-slate-900 placeholder:text-slate-500 focus:outline-none focus:bg-slate-150"
            />

            <FormInput
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Senha"
              className="w-full border-l-4 border-l-primary bg-slate-200 px-4 py-3 text-sm text-slate-900 placeholder:text-slate-500 focus:outline-none focus:bg-slate-150"
            />

            <div className="mt-2 flex items-center gap-4">
              <Button type="submit" loading={loading} size="lg">
                {loading ? 'Entrando...' : 'Entrar'}
              </Button>
              <a href="/esqueceu-senha" className="text-sm font-medium text-primary hover:underline">
                Esqueceu a senha?
              </a>
            </div>
          </form>
        </div>
      </div>

      {/* Right — accent panel */}
      <div className="relative hidden flex-1 overflow-hidden bg-primary lg:block">
        <div
          className="absolute inset-0 opacity-[0.15]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.8) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.8) 1px, transparent 1px)`,
            backgroundSize: '40px 40px',
          }}
        />
      </div>
    </div>
  );
}
